module.exports = __webpack_public_path__ + "static/media/po.393d1ef4.png";